export default __webpack_public_path__ + "static/media/tele-plan-carousel-2.4447e79a.png";